import { MtProjectGroup } from "server/models"
import { OrderType } from "client/utils"

export interface ProjectGroupProps {
    groupId: number
}
export type ProjectGroupValidation = { [key in keyof MtProjectGroup]?: string}

export interface ProjectGroupList { [groupId: number]: MtProjectGroup }
export interface ProjectGroupFilters {
    search?: string
}

export interface ProjectGroupState {
    groupList: ProjectGroupList
    groupIds: readonly number[]
    groupEdit: MtProjectGroup

    sortColumn: keyof MtProjectGroup
    sortOrder: OrderType
    filters: ProjectGroupFilters

    reloadList: boolean
    reloadEdit: boolean
}

export const PROJECT_GROUP_LIST = "PROJECT_GROUP_LIST"
export const PROJECT_GROUP_IDS = "PROJECT_GROUP_IDS"
export const PROJECT_GROUP_EDIT = "PROJECT_GROUP_EDIT"

export const PROJECT_GROUP_SORT = "PROJECT_GROUP_SORT"
export const PROJECT_GROUP_FILTERS = "PROJECT_GROUP_FILTERS"

export const PROJECT_GROUP_RELOAD_LIST = "PROJECT_GROUP_RELOAD_LIST"
export const PROJECT_GROUP_RELOAD_EDIT = "PROJECT_GROUP_RELOAD_EDIT"
